<template>
  <div>
    <div class="confirm-modal-block">
      <div class="confirm-modal-header-block">
        <p class="confirm-modal-header">
          {{ header }}
        </p>
        <p class="confirm-modal-subheader"
        :class="hidePopup ? 'mb-1':''">
          {{ subheader }}
        </p>
      </div>
      <div  v-if = "hidePopup" class="custom-control">
              <input type="checkbox" id="popup-hide" class="custom-control-input"
              @click="hidePopupMessage"
           />
              <label for="popup-hide" class="custom-control-label font-16" style="padding-top: 7px">
                {{ $resourceString["virtualtray.confirm.modal.hide.msg"] }}
              </label>
            </div>
      <button class="confirm-modal-go-back-button" @click="handleGoBackClick">
        {{ $resourceString["virtualtray.confirm.modal.no.button"] }}
      </button>
      <button class="confirm-modal-continue-button" @click="onConfirm">
        {{ $resourceString["virtualtray.confirm.modal.yes.button"] }}
      </button>
    </div>
    <button
      class="confirm-modal-close-button wf-modal-button-close btn button-full"
      type="button"
      @click="handleGoBackClick"
    >
      <span
        class="
          confirm-modal-close-label
          png-icon
          png-icon-icons-symbols--k-txtclose
        "
        aria-label="Close modal"
      />
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["header", "subheader", "close", "confirm", "callback","hidePopup",'isMyProject'],
  data() {
    return {
      setCheckBox:false
    };
  },
  methods: {
    ...mapActions({
      fetchTrayDetails: "myProject/fetchTrayDetails",
    }),
    onConfirm() {
      if(this.isMyProject){
        this.fetchTrayDetails(this.isMyProject);
        this.close();
      }else{
        this.confirm();
      }
      if (this.callback) {
        this.callback();
      }
      if(this.setCheckBox){
        localStorage.setItem("vtConfirmModalHide", "true");
      }
    },
    hidePopupMessage(){
      this.setCheckBox = !this.setCheckBox;
    },
    handleGoBackClick(){
      this.close()
      localStorage.setItem("vtConfirmModalHide", "false");

    }
  },
};
</script>

<style>
</style>
